
        import '/home/builduser/work/c1dd1064fea009a6/santa-editor/packages/quickEditEngine/components/styles/genericComponentControl.scss.css.virtualfile';
        module.exports = {"quickEditGenericThumbnail":"_quickEditGenericThumbnail_4k2yg_7"};